import React, { useEffect } from 'react';
import { format as formatDate } from 'date-fns';
import { orderBy } from 'lodash';
import { Button } from 'reactstrap';
import numeral from 'numeral';

import firebase from '../../firebase';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import AdminPage from '../hocs/AdminPage';
import AdminEventHeader from '../AdminEventHeader';
import TenantLink from '../TenantLink';

const db = firebase.firestore();

export default AdminPage(function AdminEventCancellationNoticesEmailHistories(props) {
  const {
    user,
    match: {
      params: { eventId },
    },
    addBreadNavValues,
    history,
  } = props;

  const event = useDocumentSubscription(db.collection('events').doc(eventId), [eventId]);
  const emailHistories = useCollectionSubscription(
    event?.ref.collection('emailHistories').where('type', '==', 'eventCancellationNotice').orderBy('createdAt', 'desc'),
    [event]
  );

  useEffect(() => {
    addBreadNavValues({ event });
  }, [event]);

  return (
    event != null && (
      <div>
        <div className="admin-event-cancellation-notices-email-histories container-fluid py-5 position-relative">
          <AdminEventHeader activeTab="emailHistories" event={event} user={user} />
          <div className="bg-white p-4">
            <div className="row">
              <div className="col-12">
                <div className="mb-3">
                  {numeral(emailHistories.length).format()}件
                </div>
                {emailHistories.length > 0 ? (
                  <table className="table">
                    <thead className="thead-light text-center">
                      <tr>
                        <th style={{ minWidth: 150 }}>送信日時</th>
                        <th style={{ minWidth: 200 }}>件名</th>
                        <th style={{ minWidth: 100 }}>送信件数</th>
                        <th style={{ minWidth: 150 }}>送信者</th>
                      </tr>
                    </thead>
                    <tbody>
                      {emailHistories.map((history) => {
                        const { id, subject, sentCount, createdBy, createdAt } = history;
                        return (
                          <tr key={id}>
                            <td>
                              <TenantLink to={`/admin/events/${eventId}/emailHistories/${id}`}>
                                {createdAt.toDate().toLocaleString()}
                              </TenantLink>
                            </td>
                            <td>{subject}</td>
                            <td>{numeral(sentCount).format()}件</td>
                            <td>{createdBy.displayName}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <div>メール送信履歴はありません</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
});
